export function isMediaRecorderSupportedWavFormat(): boolean {
  return window.MediaRecorder && window.MediaRecorder.isTypeSupported('audio/wav');
}

export async function isWebPSupported(): Promise<boolean> {
  // export to helper?
  return new Promise((resolve) => {
    const webP = new Image();

    // eslint-disable-next-line max-len
    webP.src =
      'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
    webP.onload = webP.onerror = (): void => {
      resolve(webP.height === 2);
    };
  });
}
